<template>
  <div class="client-bids min-vh-100">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Settings</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="settings-card">
                  <div class="settings-row">
                    <label class="settings-label"
                      >Bid Rejection Threshold </label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="bidRejectionThreshold"
                      placeholder="0.00"
                    />
                  </div>

                  <div class="settings-row">
                    <label class="settings-label">Global Spread</label>
                    <input
                      type="number"
                      class="settings-input"
                      v-model="globalSpread"
                      placeholder="0.00"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      >Offer Notification Threshold</label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="priceDiffThresholdNotif"
                      placeholder="0.00"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      >Material Event Look Up Period</label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="materialEventCheckDayLimit"
                      placeholder="0.00"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      >Push Notification Interval (mins)</label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="pushNotifInterval"
                      placeholder="0.00"
                    />
                  </div>
                  <div class="settings-row">
                    <label class="settings-label"
                      > MSRB DATA period(In Months)</label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="supportDataDuration"
                      placeholder="0.00"
                    />
                  </div>


                  <div class="settings-row">
                    <label class="settings-label"
                      >Email Notification Interval (mins)</label
                    >
                    <input
                      type="number"
                      class="settings-input"
                      v-model="emailNotifInterval"
                      placeholder="0.00"
                    />
                  </div>
               
                  <div class="settings-row">
                    <label class="settings-label"
                      >Settlement Date </label
                    >
                    <div style="width: 350px;">
                      <datepicker 
                          
                          v-model="settlementDateOffset" 
                          placeholder="mm/dd/yyyy" 
                          typeable name="settlementDateOffset" 
                          format="MM/dd/yyyy" 
                          :calendar-button="true" 
                          calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                  
                  </div>

                  <div class="button-wrap">
                    <button
                      class="btn btn-primary btn-sm"
                      @click="saveSettings"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from "vuejs-datepicker";

export default {
  data () {
    return {
      bidRejectionThreshold: null,
      globalSpread: null,
      priceDiffThresholdNotif: null,
      materialEventCheckDayLimit: null,
      pushNotifInterval: null,
      emailNotifInterval: null,
      supportDataDuration: null,
      settlementDateOffset: null,
    }
  },
  components: {
    Datepicker
  },
  methods: {
    getUserSetting () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/tradebook/setting-list?cognitoSub=' +
            authService.getUser().cognitoSub,
          auth
        )
        .then(result => {
          this.userSettings = result.data
          this.userSettings.forEach(element => {
            if (
              element.setting == 'CLIENT_OFFERING_FEED_BID_REJECTION_THRESHOLD'
            ) {
              this.bidRejectionThreshold = element.value
            }
            if (element.setting == 'CLIENT_OFFERING_FEED_GLOBAL_SPREAD') {
              this.globalSpread = element.value
            }
            if (
              element.setting ==
              'CLIENT_OFFERING_FEED_PRICE_DIFF_THRESHOLD_NOTIF'
            ) {
              this.priceDiffThresholdNotif = element.value
            }
            if (
              element.setting ==
              'CLIENT_OFFERING_FEED_MATERIAL_EVENT_CHECK_DAY_LIMIT'
            ) {
              this.materialEventCheckDayLimit = element.value
            }
            if (element.setting == 'CLIENT_OFFERING_FEED_PUSH_NOTIF_INTERVAL') {
              this.pushNotifInterval = element.value
            }
            if (
              element.setting == 'CLIENT_OFFERING_FEED_EMAIL_NOTIF_INTERVAL'
            ) {
              this.emailNotifInterval = element.value
            }
            if (element.setting == 'CLIENT_OFFERING_DEFAULT_MSRB_HISTORY') {
              this.supportDataDuration = element.value
            }
            if (element.setting == 'CLIENT_OFFERING_FEED_SETTLEMENT_DATE') {
              this.settlementDateOffset = element.value
            }
          })
          this.loading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    saveSettings () {
      let dataToSend = [
        {
          setting: 'CLIENT_OFFERING_FEED_BID_REJECTION_THRESHOLD',
          dataType: 'NUMERIC',
          value: this.bidRejectionThreshold ? this.bidRejectionThreshold : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        {
          setting: 'CLIENT_OFFERING_FEED_GLOBAL_SPREAD',
          dataType: 'NUMERIC',
          value: this.globalSpread ? this.globalSpread : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },

        {
          setting: 'CLIENT_OFFERING_FEED_PRICE_DIFF_THRESHOLD_NOTIF',
          dataType: 'NUMERIC',
          value: this.priceDiffThresholdNotif ? this.priceDiffThresholdNotif : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        {
          setting: 'CLIENT_OFFERING_FEED_MATERIAL_EVENT_CHECK_DAY_LIMIT',
          dataType: 'NUMERIC',
          value: this.materialEventCheckDayLimit ? this.materialEventCheckDayLimit : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        {
          setting: 'CLIENT_OFFERING_FEED_PUSH_NOTIF_INTERVAL',
          dataType: 'NUMERIC',
          value: this.pushNotifInterval ? this.pushNotifInterval : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        {
          setting: 'CLIENT_OFFERING_FEED_EMAIL_NOTIF_INTERVAL',
          dataType: 'NUMERIC',
          value: this.emailNotifInterval ? this.emailNotifInterval : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        
        {
          setting: 'CLIENT_OFFERING_DEFAULT_MSRB_HISTORY',
          dataType: 'NUMERIC',
          value: this.supportDataDuration ? this.supportDataDuration : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
        {
          setting: 'CLIENT_OFFERING_FEED_SETTLEMENT_DATE',
          dataType: 'STRING',
          value: this.settlementDateOffset ? this.moment(this.settlementDateOffset).format("MM/DD/YYYY") : null,
          updateByCognitoSub: authService.getUser().cognitoSub
        },
      ]
      this.loading = false
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .post(config.baseUrlBidSide + '/tradebook/setting', dataToSend, auth)
        .then(() => {
          this.loading = false
          this.$alert('Saved successfully ', '', 'success')
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  mounted () {
    this.getUserSetting()
    console.log('ClientSettings component mounted.')
  }
}
</script>
<style scoped>
.settings-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.settings-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

.settings-label {
  width: 250px; /* Fixed label width */
  font-size: 14px;
  font-weight: 500;
  color: #bbbbbb;
}

.settings-input {
  width: 350px; /* FIX INPUT WIDTH */
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.button-wrap {
  display: flex;
  justify-content: flex-end; /* Button moves to right */
  margin-top: 10px;
}
</style>
